module Client.Components.EmailAddress

open Client
open Shared
open global.Elmish
open Fable.Core.JsInterop
open System
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Fable.Core.Experimental
open Fable.Core.JS
open System.Text.RegularExpressions

let strOption (s : string) = if String.IsNullOrWhiteSpace s then None else Some s

let validateAddress v =
  match v with
  | None -> Error "Please enter an email address."
  | Some e ->
    match String.IsNullOrWhiteSpace e with
    | true -> Error "Please enter an email address."
    | false ->
      let regexExpression = """^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$"""
      match Regex.IsMatch(e, regexExpression) with
      | true -> Ok e
      | false -> Error "Please enter a valid email address."

type FieldState =
  { Validate : bool
    FieldWarning : string option
    FieldValue : string option } with
    static member init (v : string option) =
      { Validate = v.IsSome; FieldValue = v; FieldWarning = None; }
    member this.setValue callBackFn (v : string option) =
      match validateAddress v with
      | Error msg -> 
        callBackFn None
        { this with FieldValue = v; FieldWarning = Some msg; }
      | Ok e -> 
        Some e |> callBackFn
        { this with FieldValue = Some e; FieldWarning = None; }

let view = React.functionComponent (fun (inputProps: {| initialValue : string option; allowEntry : bool; isRequired : bool; returnResult: string option -> unit; |}) ->
  let state, setState = React.useState(FieldState.init inputProps.initialValue)
  Mui.textField [
    textField.placeholder "Please enter your email address"
    prop.type'.email
    if inputProps.allowEntry then textField.variant.outlined else textField.variant.filled
    if inputProps.initialValue.IsSome then textField.defaultValue inputProps.initialValue.Value
    textField.margin.normal
    textField.fullWidth true
    textField.label "Email Address"
    textField.name "Email"
    textField.required inputProps.isRequired
    if inputProps.allowEntry 
    then
      match state.Validate, state.FieldWarning with
      | false, _ 
      | true, None -> ()
      | true, Some err ->
        textField.error true
        textField.helperText err
      prop.onBlur (fun _ -> setState {state with Validate = true;})
      textField.onChange (fun (ev : Browser.Types.Event) -> setState ( strOption !!ev.target?value |> state.setValue inputProps.returnResult ))
    else
      textField.InputProps [
        input.readOnly true
        input.endAdornment
          (Mui.fab [
              fab.size.small
              fab.children [ 
                Mui.tooltip [
                  tooltip.title "Clear"
                  tooltip.children ( closeIcon [])
                ]
              ]
              prop.onClick (fun _ -> inputProps.returnResult None) ])
      ]
  ]
)